export default (value) => value && !!value.getElementsByClassName;
